import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerLink',
  props: {
    entity: null,
    hideAge: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const onClick = event => {
      if (!props.disabled) {
        router.push({
          name: 'players.show',
          params: {
            id: props.entity.id
          }
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["font-semibold", {
          'cursor-pointer': !__props.disabled
        }]),
        onClick: onClick
      }, [_createTextVNode(_toDisplayString(__props.entity.shortName) + " ", 1), !__props.hideAge ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("(" + _toDisplayString(__props.entity.age) + ")", 1)], 64)) : _createCommentVNode("", true)], 2);
    };
  }
});